import {mapActions, mapMutations, mapState, mapGetters} from 'vuex'


export default {
    data() {
        return {
           
        }
    },
    methods: {
        defaultRule(model) {
            var rule = {};
            for(var field in model){
                if(!model.hasOwnProperty(field)){
                    continue;
                }
                rule[field] = {}
            }
            console.log('rule is ' + JSON.stringify(rule))
            return rule;
        }
    },
}



// WEBPACK FOOTER //
// ./src/modules/mixin.js